<template>
  <svg width="287" height="186" viewBox="0 0 287 186" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m251.393 155.886-220.631-6.325a20.4 20.4 0 0 1-13.333-5.465 20.4 20.4 0 0 1-6.396-12.917L.383 25.898a20.46 20.46 0 0 1 5.073-15.652A20.44 20.44 0 0 1 20.41 3.398L265.988.002a20.45 20.45 0 0 1 15.508 6.803 20.48 20.48 0 0 1 5.071 16.164L272.268 137.97a20.5 20.5 0 0 1-6.985 12.985 20.47 20.47 0 0 1-13.89 4.93"
      fill="#C4A5A6"
    />
    <mask id="a" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="287" height="156">
      <path
        d="m251.393 155.886-220.631-6.325a20.4 20.4 0 0 1-13.333-5.465 20.4 20.4 0 0 1-6.396-12.917L.383 25.898a20.46 20.46 0 0 1 5.073-15.652A20.44 20.44 0 0 1 20.41 3.398L265.988.002a20.45 20.45 0 0 1 15.508 6.803 20.48 20.48 0 0 1 5.071 16.164L272.268 137.97a20.5 20.5 0 0 1-6.985 12.985 20.47 20.47 0 0 1-13.89 4.93"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        d="M189.022 209.503h176.293a6.36 6.36 0 0 0 6.364-6.367v-100.06a6.37 6.37 0 0 0-6.364-6.368H189.022a6.363 6.363 0 0 0-6.364 6.368v100.017a6.4 6.4 0 0 0 1.858 4.522 6.4 6.4 0 0 0 4.506 1.888m-214.097-26.575h177.82a6.366 6.366 0 0 0 6.365-6.368V30.398a6.365 6.365 0 0 0-6.365-6.368h-177.82a6.363 6.363 0 0 0-6.364 6.368V176.56a6.37 6.37 0 0 0 6.364 6.368"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M44.127 68.562h8.613a1.833 1.833 0 0 0 1.825-1.613l.678-6.113a1.84 1.84 0 0 0-1.824-2.038h-9.97a1.84 1.84 0 0 0-1.825 2.038l.679 6.113a1.91 1.91 0 0 0 1.824 1.613"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.473 58.798s3.395-.34 4.073-4.924c0 0-3.055.891-4.03 3.056 0 0-.425-4.84-2.716-5.306 0 0-1.018 3.608.594 5.391 0 0-1.23-2.038-4.37-1.995a5.77 5.77 0 0 0 3.903 3.736"
        fill="#D6585D"
      />
      <path
        d="M190.38 117.807h38.271a1.797 1.797 0 0 0 1.782-1.783v-11.632a1.8 1.8 0 0 0-.526-1.257 1.8 1.8 0 0 0-1.256-.526H190.38a1.8 1.8 0 0 0-1.256.526 1.8 1.8 0 0 0-.526 1.257v11.632a1.73 1.73 0 0 0 .509 1.273 1.75 1.75 0 0 0 1.273.51"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M205.103 106.727h8.825a.65.65 0 0 0 .637-.637.657.657 0 0 0-.637-.637h-8.825a.65.65 0 0 0-.637.637.654.654 0 0 0 .637.637"
        fill="#D6585D"
      />
      <path
        d="M190.38 137.25h38.271a1.793 1.793 0 0 0 1.782-1.783v-11.632a1.8 1.8 0 0 0-.526-1.257 1.8 1.8 0 0 0-1.256-.526H190.38a1.8 1.8 0 0 0-1.256.526 1.8 1.8 0 0 0-.526 1.257v11.632a1.73 1.73 0 0 0 .509 1.273 1.75 1.75 0 0 0 1.273.51"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M205.103 126.17h8.825a.65.65 0 0 0 .637-.637.657.657 0 0 0-.637-.637h-8.825a.65.65 0 0 0-.637.637.654.654 0 0 0 .637.637"
        fill="#D6585D"
      />
      <path
        d="M12.73 131.179H51a1.79 1.79 0 0 0 1.783-1.783v-11.632A1.797 1.797 0 0 0 51 115.981H12.73a1.796 1.796 0 0 0-1.782 1.783v11.632a1.74 1.74 0 0 0 1.782 1.783"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.453 120.057h8.825a.655.655 0 0 0 .636-.637.655.655 0 0 0-.636-.637h-8.825a.654.654 0 0 0-.637.637.624.624 0 0 0 .637.637"
        fill="#D6585D"
      />
      <path
        d="M61.862 131.179h38.271a1.793 1.793 0 0 0 1.782-1.783v-11.632a1.796 1.796 0 0 0-1.782-1.783h-38.27a1.796 1.796 0 0 0-1.783 1.783v11.632a1.74 1.74 0 0 0 1.782 1.783"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M76.585 120.057h8.826a.655.655 0 0 0 .636-.637.655.655 0 0 0-.636-.637h-8.826a.654.654 0 0 0-.636.637.624.624 0 0 0 .636.637"
        fill="#D6585D"
      />
      <path
        d="M239.131 117.807h38.271a1.8 1.8 0 0 0 1.782-1.783v-11.632a1.8 1.8 0 0 0-.526-1.257 1.8 1.8 0 0 0-1.256-.526h-38.271a1.8 1.8 0 0 0-1.256.526 1.8 1.8 0 0 0-.526 1.257v11.632a1.793 1.793 0 0 0 1.782 1.783"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M253.896 106.727h8.825a.657.657 0 0 0 .637-.637.656.656 0 0 0-.637-.637h-8.825a.653.653 0 0 0-.636.637.617.617 0 0 0 .636.637"
        fill="#D6585D"
      />
      <path
        d="M239.131 137.25h38.271a1.795 1.795 0 0 0 1.782-1.783v-11.632a1.8 1.8 0 0 0-.526-1.257 1.8 1.8 0 0 0-1.256-.526h-38.271a1.8 1.8 0 0 0-1.256.526 1.8 1.8 0 0 0-.526 1.257v11.632a1.793 1.793 0 0 0 1.782 1.783"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M253.896 126.17h8.825a.657.657 0 0 0 .637-.637.656.656 0 0 0-.637-.637h-8.825a.653.653 0 0 0-.636.637.617.617 0 0 0 .636.637"
        fill="#D6585D"
      />
      <path
        d="M-43.022 68.562H150.03a1.973 1.973 0 0 0 1.952-1.953V32.775a1.976 1.976 0 0 0-1.952-1.953H-43.022a1.973 1.973 0 0 0-1.952 1.953v33.834a1.975 1.975 0 0 0 1.952 1.953m0 41.985H150.03a1.97 1.97 0 0 0 1.952-1.952V74.76a1.976 1.976 0 0 0-1.952-1.953H-43.022a1.97 1.97 0 0 0-1.952 1.953v33.835a1.974 1.974 0 0 0 1.952 1.952"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M138.99 47.209h-4.201v21.353h4.201z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M134.815 52.986h-4.37v15.538h4.37zM12.39 89.126h-4.2v21.353h4.2z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.215 94.946h-4.37v15.538h4.37zm12.742-5.82h-4.2v21.353h4.2z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m24.891 88.679-4.005 1.265 6.425 20.363 4.005-1.266zm-8.114 6.267h-4.37v15.538h4.37zm52.29-47.737h-4.2v21.353h4.2z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M64.888 52.986h-4.37v15.538h4.37zm45.641-5.777h-4.201v21.353h4.201z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m114.471 46.732-4.006 1.266 6.425 20.362 4.006-1.265zm-8.117 6.254h-4.371v15.538h4.371z"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m8.275 49.968-.467-6.325a.7.7 0 0 1 .721-.764h3.65a.726.726 0 0 1 .72.764l-.466 6.325s3.818 2.462 3.776 4.5c-.043 1.57-.976 9.085-1.4 12.396a1.835 1.835 0 0 1-1.825 1.613H7.723a1.83 1.83 0 0 1-1.824-1.613c-.425-3.311-1.358-10.825-1.4-12.396-.043-2.038 3.776-4.5 3.776-4.5"
        fill="#D6585D"
      />
      <path
        d="m288.73 145.273-406.13-4.033"
        stroke="#D6585D"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="m138.998 83.887-8.273 66.141a1.2 1.2 0 0 0 .288.946 1.2 1.2 0 0 0 .9.412 1.19 1.19 0 0 0 1.188-1.019l9.461-64.824zm25.712 9.467 8.274 66.141a1.21 1.21 0 0 1-.694 1.249 1.2 1.2 0 0 1-1.28-.177 1.2 1.2 0 0 1-.402-.733l-9.462-64.824zm-40.137-2.59-11.117 65.716a1.22 1.22 0 0 0 .654 1.275 1.22 1.22 0 0 0 1.291-.13c.227-.18.38-.436.431-.721l12.262-64.357zm31.142-6.58 6.11 66.353a1.2 1.2 0 0 0 .484.853 1.2 1.2 0 0 0 .959.208 1.19 1.19 0 0 0 .933-1.231l-4.625-65.377z"
      fill="#C4A5A6"
    />
    <path
      d="M173.408 25.133c-4.625-.764-19.941 52.895-19.941 52.895h14.722s-7.213 8.618-7.467 9.425c-.255.806-2.885 11.716-2.885 11.716 17.608-5.603 13.704-21.183 13.704-21.183-3.776-11.675 1.485-26.618 3.734-38.971 2.249-12.354-1.867-13.882-1.867-13.882"
      fill="#D6585D"
    />
    <path
      d="M118.845 96.326s.382 5.815 15.529 6.665 34.664-.637 37.21-17.83c.042 0-49.684 6.325-52.739 11.165"
      fill="#D6585D"
    />
    <path
      d="M167.85 76.84c-4.115-15.029 11.795-48.608 5.601-51.75-6.365-3.183-30.804-1.867-37.38 3.821-6.152 5.35-8.953 45-9.292 50.009q-.053.251-.043.51c0 2.97-.424 7.98-2.588 9.55-4.2 3.057-11.116 7.685 2.122 11.081 0 0 5.728 1.316 22.063.637 22.105-.934 19.899-14.561 19.857-22.712a2.4 2.4 0 0 0-.34-1.146"
      fill="#fff"
    />
    <path
      d="M108.789 153.084s1.867 8.915 2.291 9.637c.424.721 3.606 2.292 7.934 1.019 4.328-1.274 4.455-2.887 4.455-2.887s-.848-10.231-.848-11.377-14.554-3.184-13.832 3.608"
      fill="#DDD"
    />
    <path
      d="M123.045 155.971c-.212-2.802-.467-5.901-.467-6.495 0-1.147-14.553-3.184-13.831 3.608 0 0 .297 1.359.636 3.057a24.9 24.9 0 0 0 13.662-.17"
      fill="#896068"
    />
    <path
      d="M110.613 161.192s-.509.807-.509 5.01-6.364 13.712-5.94 16.301c.424 2.59 18.329 3.227 19.942 1.316s-.085-16.004.042-17.49.679-4.288-.764-6.071c0 0-1.485 1.486-2.673 1.741-1.188.254-2.291-2.165-4.624-2.59-2.334-.424-3.861 2.335-4.116 2.59s-1.273-.085-1.358-.807"
      fill="#1D1D1F"
    />
    <path
      d="M111.377 171.126s3.606-2.504 9.334.34m-10.734 3.651s5.006-3.524 10.777.722"
      stroke="#fff"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M154.909 157.924s2.885 8.065 4.455 9.509c1.57 1.443 5.771 1.571 8.656 0s2.758-3.948 2.758-3.948-2.504-13.203-3.055-13.543-12.814 4.118-12.814 7.982"
      fill="#DDD"
    />
    <path
      d="M154.909 157.924s.722 1.995 1.613 4.203c4.921.849 9.207-.807 13.365-3.184-.764-3.863-1.825-8.788-2.164-9-.594-.382-12.814 4.118-12.814 7.981"
      fill="#896068"
    />
    <path
      d="M158.049 165.183s-.382.128.721 3.694c.552 1.91-5.558 11.716-5.431 14.136.128 2.42 5.219 2.844 9.25 2.972 6.152.17 10.183-1.061 10.522-5.01s-.721-11.631-.721-13.33-.552-3.65-1.952-5.943c0 0 .127 3.184-1.145 3.778-1.273.595-3.649-1.698-5.474-1.231-1.824.467-2.588 1.868-3.352 2.675s-2.206-1.274-2.418-1.741"
      fill="#1D1D1F"
    />
    <path
      d="M159.916 173.419s3.309-3.311 9.122-.764m-10.946 4.542s5.218-4.33 10.904-.34"
      stroke="#fff"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M125.124 77.137s-19.475 10.74-24.609 20.589 2.885 41.221 2.758 47.844c-.127 6.622.721 7.599 4.413 8.999 3.691 1.401 11.71 1.104 15.062-1.4 4.328-3.227 2.334-9.128 1.358-16.26s-1.443-28.188-1.443-28.188 9.165-7.429 13.662-9.636a7.4 7.4 0 0 1 2.758-.722 1.99 1.99 0 0 1 2.08 1.601c.061.314.047.639-.043.946-1.103 3.906-2.673 13.712-2.037 18.212.594 4.203 3.522 14.603 9.25 32.221 1.145 3.481 1.527 6.283 2.927 7.472 5.898 4.967 18.712-.34 20.069-4.967.552-1.911-.848-8.406-2.673-15.495-2.588-10.146-6.067-21.524-5.813-22.755.425-2.08 5.898-21.183 4.455-29.759-3.479-20.759-19.559-12.396-42.174-8.702"
      fill="#1D1D1F"
    />
    <path
      d="M122.663 108.722s-.254-2.632-1.06-4.033m18.032-6.453s.467-2.93-.297-3.778"
      stroke="#F5F5F5"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M134.374 94.797s3.139-.254 9.928 0"
      stroke="#F5F5F5"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M127.627 33.963s-2.461.891-6.279 6.665a73 73 0 0 1-7.001 9.042s-4.37-4.797-8.952-7.853c-4.583-3.057-9.802-7.854-9.802-7.854s-3.436-1.868-5.6.68c-2.164 2.546-1.061 6.24-1.061 6.24s5.134 6.962 12.686 16.047c4.922 5.943 9.929 10.188 14.129 8.872 5.601-1.74 16.632-11.76 18.542-15.75 1.909-3.99.466-17.532-6.662-16.09"
      fill="#E21D26"
    />
    <path
      d="M114.305 49.67a14 14 0 0 1 2.248 4.203"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M95.763 34.175s-3.394-2.802-5.813-2.547c-3.14.34-3.097-.382-5.091.043-.934.212-2.63.89-4.413 3.099a27 27 0 0 0-2.418 3.353s-1.867-3.99-3.013-3.353c-1.145.636 1.57 6.75 2.504 7.386s3.69-.467 4.667 0 3.606-.382 3.606-.382l3.607-.891.933 1.018a1.12 1.12 0 0 0 1.188.298 5.98 5.98 0 0 0 3.225-3.142c1.485-3.099 1.018-4.882 1.018-4.882"
      fill="#DDD"
    />
    <path
      d="M78.028 38.124s-1.867-3.99-3.013-3.354 1.57 6.75 2.504 7.387 3.69-.467 4.667 0"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91.393 36.892s-1.23 3.227-2.758 5.307c-1.527 2.08-3.819 2.165-4.837 1.486-1.018-.68.34-5.35.636-6.495.297-1.147 1.231-2.208 1.825-.934.467.976-.212 3.31-.085 5.179"
      fill="#DDD"
    />
    <path
      d="M84.35 43.303s-1.316.806-2.08.551c-.763-.254-1.23-.806-1.357-1.952-.127-1.147.297-4.585.254-5.477-.042-.891 1.358-1.613 1.952.425s.297 3.82.679 4.245"
      fill="#DDD"
    />
    <path
      d="M81.465 42.709a6 6 0 0 1-1.995.594c-1.018.085-1.485-.594-1.824-2.675-.382-2.504-.679-5.051.212-5.179.891-.127 1.358 1.231 1.697 2.632.34 1.401.552 2.293.764 2.335m4.964-8.788s-2.418.17-3.31.17c-.89 0-3.224-.594-3.733.128-.51.721.934 2.037 3.522 2.377s5.091-1.698 3.521-2.675"
      fill="#DDD"
    />
    <path
      d="M91.393 44.152s3.352 1.103 5.686-2.25c2.079-2.972 1.272-5.52 1.272-5.52"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91.393 36.892s-1.23 3.227-2.758 5.307c-1.527 2.08-3.819 2.165-4.837 1.486-1.018-.68.34-5.35.636-6.495.297-1.147 1.231-2.208 1.825-.934.467.976-.212 3.31-.085 5.179"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.543 43.685a1.95 1.95 0 0 1-1.272.17c-.764-.255-1.23-.807-1.358-1.953-.127-1.147.297-4.585.254-5.477-.042-.891 1.358-1.613 1.952.425.424 1.528.382 2.844.51 3.65"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M81.125 42.836a4.9 4.9 0 0 1-1.655.425c-1.018.084-1.485-.595-1.824-2.675-.382-2.504-.679-5.052.212-5.179s1.358 1.231 1.697 2.632c.34 1.4.552 2.292.764 2.335m.679-6.156a14 14 0 0 1 2.376-1.91"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M132.294 11.336c-.042-.767.001-1.535.128-2.292.339-1.783 1.23-5.52 2.715-6.75 2.206-1.826 3.394.891 3.394.891s1.528-1.995 2.97-1.783 2.207 1.91 2.207 1.91 2.333-1.91 3.734-.976a4.4 4.4 0 0 1 1.782 2.377s1.485-1.698 3.054-1.018c1.57.679 1.867 4.712 1.867 4.712s1.57.891 1.91 3.99c.381 3.312-1.231 8.194-4.54 13.797 0 0-6.831-12.31-11.159-14.051s-4.285 1.485-5.643 1.57c-1.188.043-2.206-.085-2.419-2.377"
      fill="#1D1D1F"
    />
    <path
      d="M133.143 34.303s-5.304.637.891-4.967c5.346-4.84 23.166-3.48 25.458.68 1.697 3.098 3.861 11.377-3.352 16.343-7.213 4.967-19.772-.297-22.997-12.056"
      fill="#E21D26"
    />
    <path
      d="M143.326 32.732s4.964-.212 9.122-.382 10.226-.085 13.578 4.5c3.861 5.222-1.952 23.221-2.801 27.806-.848 4.585 2.419 10.104 2.249 13.882-.085 2.165-2.8 7.854-14.85 8.915-13.62 1.231-25.627-1.57-26.942-9.424-.891-5.264 2.588-8.958 1.4-17.533-.637-4.5-1.443-19.061.085-23.18 1.527-4.117 4.073-5.475 18.159-4.584"
      fill="#E21D26"
    />
    <path
      d="M138.235 28.572s-.594 4.712-.849 5.943.424 4.712 5.346 4.67c5.304-.043 8.613-4.288 8.74-5.986s-.297-9.891.425-12.608c.721-2.717-6.068-1.146-8.995.552-2.928 1.698-4.964 6.028-4.667 7.429"
      fill="#DDD"
    />
    <path
      d="M147.017 28.19c-2.757.637-6.152 3.014-9.079 2.547-.085.722-.213 1.486-.297 2.165 3.903.637 7.594-1.825 9.376-4.712"
      fill="#896068"
    />
    <path
      d="M137.81 31.756s-.678 4.882 3.437 7.301c0 0 4.752-.424 8.231-3.82a6.77 6.77 0 0 0 1.995-4.882v-.382s6.661.085 8.57 2.08c3.649 3.82-11.328 9.891-19.475 11.165 0 0-7.552-4.203-9.334-8.49-1.782-4.288 5.982-2.803 6.576-2.972"
      fill="#E21D26"
    />
    <path
      d="M139.168 40.544a56.6 56.6 0 0 0-2.461 12.438"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M137.683 53.491c.042-.552-.255-2.25-.806-2.292-.552-.043-1.188 1.57-1.231 2.122a1.034 1.034 0 0 0 .934 1.104.98.98 0 0 0 1.103-.934"
      fill="#E21D26"
    />
    <path
      d="M144.132 40.67a55.5 55.5 0 0 0 .467 12.651"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M145.702 53.661c-.085-.552-.764-2.123-1.315-2.038-.552.085-.806 1.783-.721 2.335a1.055 1.055 0 0 0 1.188.892 1.07 1.07 0 0 0 .848-1.189m-17.056 19.103a18.3 18.3 0 0 0 2.588-7.259 1.52 1.52 0 0 1 1.655-1.358c3.139.34 10.14.976 15.401.509a1.525 1.525 0 0 1 1.655 1.4c.17 1.826.976 4.925 4.116 7.94.258.212.425.516.466.848a29.6 29.6 0 0 1 .552 6.326c-.17 2.929-19.857 4.924-26.645-1.104a1.6 1.6 0 0 1-.51-1.189c.043-1.146.213-3.523.51-5.476.031-.223.103-.44.212-.637"
      fill="#E21D26"
    />
    <path
      d="M132.677 13.331s-.085 4.16-.467 7.727c-.382 3.566 0 8.32 5.728 9.806s11.286-2.844 13.365-8.533c2.079-5.688 2.164-13.372-5.134-16.386s-13.153.764-13.492 7.386"
      fill="#DDD"
    />
    <path
      d="M154.018 16.982c-.552 2.675-.933 4.118-.933 4.118l-1.782-1.868s-3.055-.424-3.48-5.9a2.69 2.69 0 0 0-1.442-2.208c-2.504-1.316-3.819.637-8.698.297-1.655-.127-4.201-.382-4.116-2.93.212-6.622 10.438-6.112 15.275-3.098s5.728 8.957 5.176 11.59"
      fill="#1D1D1F"
    />
    <path d="M149.266 19.615s1.103-2.505 2.928-2.25c1.951.254 2.121 6.113-2.928 6.452" fill="#DDD" />
    <path
      d="M135.35 16.346a8 8 0 0 1 .042 1.74 6 6 0 0 1-.339 1.74c-.043.128-.128.298-.17.425-.043.128-.085.213-.127.34a.8.8 0 0 0 .042.552c.29.435.727.752 1.23.891a1.74 1.74 0 0 1-.933 0 1.57 1.57 0 0 1-.849-.551 1.2 1.2 0 0 1-.254-.51 1.2 1.2 0 0 1 0-.552q.063-.24.17-.467.072-.175.169-.34c.425-1.06.637-2.165 1.019-3.268"
      fill="#1D1D1F"
    />
    <path
      d="M137.726 25.515s.297-.636 1.018-.085c.721.552 1.018.34 1.4-.127s.552.425 1.4.085"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M141.374 15.285a1.14 1.14 0 0 1 .204-1.311c.111-.113.244-.202.39-.26.849-.382 2.249.255 3.055 1.104s.382 1.273-.594.849c-.976-.425-1.4-.51-2.249-.213a.665.665 0 0 1-.806-.17m-6.025-.424a1.13 1.13 0 0 0 .118-.777 1.13 1.13 0 0 0-.415-.667c-.594-.424-1.57 0-2.079.68-.466.594-.254.934.382.764.637-.17.891-.255 1.443.085a.42.42 0 0 0 .551-.085m16.972 4.84a1.3 1.3 0 0 0-.467-.17.2.2 0 0 0-.128.025.2.2 0 0 0-.084.102c-.11.255-.167.53-.169.807-.013.4-.115.79-.297 1.146a.86.86 0 0 1-.552.382.7.7 0 0 1-.297.043c-.085 0-.212-.043-.297-.043.339-.212.594-.425.594-.637s.042-.552.085-.934c.013-.434.196-.845.509-1.146a.63.63 0 0 1 .382-.17.85.85 0 0 1 .382.085c.155.137.272.313.339.51m-18.075-1.147a.596.596 0 0 0 .679-.552l.042-.382a.59.59 0 0 0-.316-.614.6.6 0 0 0-.235-.065.6.6 0 0 0-.614.316.6.6 0 0 0-.065.236l-.042.382a.582.582 0 0 0 .551.68m7.595.72a.6.6 0 0 0 .614-.316.6.6 0 0 0 .065-.235l.042-.383a.59.59 0 0 0-.316-.614.6.6 0 0 0-.235-.065.594.594 0 0 0-.679.552l-.043.382a.647.647 0 0 0 .552.68"
      fill="#1D1D1F"
    />
    <path
      d="M163.734 35.873a3.65 3.65 0 0 1 2.631 1.062c.848.806 2.63 2.504 6.11 5.773 5.6 5.307 6.364 6.325 6.364 6.325s4.922 3.864 5.431 8.66c.509 4.798-2.716 11.25-11.116 5.86-8.401-5.392-12.475-9-14.172-12.652-1.527-3.268-.636-14.9 4.752-15.028"
      fill="#E21D26"
    />
    <path
      d="M176.336 53.66a29.5 29.5 0 0 1 6.322-8.617c4.413-4.203 9.631-9.382 10.607-10.4.976-1.02 3.352-3.355 6.577-.85s1.357 6.877 1.357 6.877-5.643 9.085-10.31 16.811c-4.667 7.727-9.419 10.274-15.444 7.345-6.025-2.93.891-11.165.891-11.165"
      fill="#E21D26"
    />
    <path
      d="M193.265 35.28s2.419-3.27 3.395-4.416c.975-1.146 2.757-2.886 5.091-2.207s3.564-.764 5.346 1.104 3.013 5.306 4.158 6.58c1.146 1.273.849 1.613 2.673 1.57s3.31.383 2.546 1.401c-.764 1.02-5.728 1.274-6.407 1.19-.679-.086-3.861.339-4.667-.043s-.679-.043-1.358-.425-2.418-1.23-2.418-1.23a9 9 0 0 1-1.273 1.867c-.721.764-3.861.637-5.898-1.74-1.739-2.038-1.188-3.651-1.188-3.651"
      fill="#DDD"
    />
    <path
      d="M211.255 36.383c1.146 1.273.849 1.613 2.673 1.57s3.31.383 2.546 1.401c-.764 1.02-5.728 1.274-6.407 1.19"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M204.212 39.142c.085-2.25.806-4.033 1.485-3.778s1.06 5.052-.552 6.156c-1.612 1.103-5.94-4.84-6.789-5.222"
      fill="#DDD"
    />
    <path
      d="M204.933 41.138s.891 1.74 2.206.891c1.315-.85 2.631-4.755 2.885-5.604.255-.849-1.357-1.188-2.418.892s-1.825 2.377-1.825 2.377"
      fill="#DDD"
    />
    <path
      d="M207.479 41.307a1.696 1.696 0 0 0 1.909.764c1.315-.34 3.012-2.971 3.819-3.82.806-.85-.213-1.953-1.613-.934s-2.418 1.995-3.097 2.207m-1.994-10.23s1.018.51 2.334 2.292c1.315 1.783 3.861 2.038 4.158 2.972s-2.376 1.316-4.498.297c-2.121-1.019-2.927-5.35-1.994-5.561"
      fill="#DDD"
    />
    <path
      d="M190.592 37.317a5.7 5.7 0 0 0 1.994 5.222 6.22 6.22 0 0 0 6.619 1.273"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M204.212 39.142c.085-2.25.806-4.033 1.485-3.778s1.06 5.052-.552 6.156c-1.612 1.103-5.94-4.84-6.789-5.222"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M207.139 42.029c1.316-.807 2.631-4.755 2.886-5.604.254-.849-1.358-1.188-2.419.892a7.3 7.3 0 0 1-1.442 2.122"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M207.818 41.69a1.61 1.61 0 0 0 1.57.339c1.315-.34 3.012-2.972 3.818-3.82.807-.85-.212-1.954-1.612-.935-1.103.764-1.952 1.571-2.588 1.953m1.612-3.777s-1.145-1.954-1.569-2.506"
      stroke="#CB8488"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M179.051 49.16s-2.376 2.76-2.885 6.071"
      stroke="#1D1D1F"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M43.066 87.453h-4.158l-.212 7.557h3.989z" fill="#E21D26" />
    <path
      d="m38.696 95.01-2.503 76.073a1.37 1.37 0 0 0 1.4 1.444 1.394 1.394 0 0 0 1.4-1.316l3.691-76.202z"
      fill="#C4A5A6"
    />
    <path d="M249.399 87.453h-4.116l.34 7.557h4.03z" fill="#E21D26" />
    <path
      d="m245.623 95.01 3.691 76.201a1.403 1.403 0 1 0 2.8-.128l-2.503-76.074zM54.14 77.137l-2.333 71.532a1.18 1.18 0 0 0 .72 1.142c.148.061.307.092.468.089a1.18 1.18 0 0 0 1.188-1.146l3.479-71.617zm180.027 0 2.333 71.532a1.17 1.17 0 0 1-.327.873 1.17 1.17 0 0 1-.861.358 1.18 1.18 0 0 1-1.188-1.146l-3.479-71.617z"
      fill="#C4A5A6"
    />
    <path d="M261.151 85.84H27.155L51.68 74.165h184.99z" fill="#fff" />
    <path d="M261.151 85.84H27.155v3.184h233.996z" fill="#C4A5A6" />
    <path
      d="M218.935 74.547s-1.995-.976-2.673-2.929c-.679-1.953.509-3.269 1.018-3.141.509.127 1.273 2.59 1.909 2.59s.509-4.33 1.782-4.798 1.146 4.288 1.188 4.67c.085.976 1.74-1.146 2.334-1.995.721-1.062 3.055 2.76-1.825 5.603a10.5 10.5 0 0 1-3.733 0"
      fill="#E21D26"
    />
    <path
      d="M227.166 75.014v.17a22.2 22.2 0 0 1-1.443 7.387 1.12 1.12 0 0 1-.976.68h-7.637a1.05 1.05 0 0 1-.976-.68 22 22 0 0 1-1.442-7.387v-.17a.77.77 0 0 1 .493-.752q.151-.06.313-.054h10.862a.754.754 0 0 1 .806.806m-28.682-3.141c-3.31.34-4.158 9.297-10.438 10.188 0 0-1.145.043-3.012.085-5.389.17-16.505.425-21.002.043a17 17 0 0 0 1.951-.128c1.952-.255 3.352-1.316 4.498-2.59 2.546-2.971 3.691-7.344 5.94-7.556h22.063z"
      fill="#1D1D1F"
    />
    <path
      d="M170.438 79.472a7.03 7.03 0 0 1-4.497 2.59q-.973.122-1.952.127c-4.752 0-6.152-2.632-6.152-2.632s7.594.34 12.601-.085"
      fill="#E21D26"
    />
    <path d="M138.362 83.08h-30.804v-2.292h33.095a2.283 2.283 0 0 1-2.291 2.292" fill="#1D1D1F" />
    <path
      d="M114.177 83.08H66.699a3.39 3.39 0 0 1-3.267-2.546l-7.807-31.118a1.853 1.853 0 0 1 1.782-2.292h47.479a3.39 3.39 0 0 1 3.267 2.547l7.807 31.117a1.84 1.84 0 0 1-.972 2.11 1.8 1.8 0 0 1-.811.183"
      fill="#1D1D1F"
    />
    <path
      d="M86.13 67.79c1.123-1.29.644-3.547-1.07-5.041-1.715-1.494-4.015-1.658-5.138-.367s-.645 3.548 1.07 5.041c1.714 1.494 4.014 1.658 5.137.367"
      fill="#F5F5F5"
    />
    <path
      d="M140.95 78.496h-10.056a.9.9 0 0 1-.891-.892 4.643 4.643 0 0 1 4.625-4.627h2.546a4.643 4.643 0 0 1 4.625 4.627.87.87 0 0 1-.233.628.85.85 0 0 1-.616.264"
      fill="#1D1D1F"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconFired',
});
</script>
